import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LogoContainer from '../components/LogoContainer';
import { motion } from 'framer-motion';

// Iletisim bileşeninde kullanılan iframe ve diğer sabit metinler
const Iletisim = () => {
  // useTranslation hook'unu import edip t fonksiyonunu alıyoruz.
  const { t } = require('react-i18next').useTranslation();

  return (
    <div className="bg-white min-h-screen pb-20">
      {/* İletişim başlığı */}
      <div className="grid grid-cols-14 md:grid-cols-8">
        <div className="col-start-2 col-span-12 md:col-start-2 md:col-span-6">
          {/* Başlık: Çeviri dosyasından alınan metin */}
          <div className="text-45 font-light mb-10">{t('iletisim.title')}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-20 md:gap-5">
            {/* Sol sütun */}
            <div className="flex flex-col">
              {/* Google Maps iframe */}
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3156.9920636382935!2d29.099915779866958!3d37.7926939268272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzfCsDQ3JzM2LjciTiAyOcKwMDYnMDIuMSJF!5e1!3m2!1str!2str!4v1743903668382!5m2!1str!2str" 
                width="100%" 
                height="275" 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Map 1"
              ></iframe>
              <div className="mt-5">
                {/* Adres ve telefon bilgisi */}
                <a 
                  href="https://maps.app.goo.gl/WeqHLSssyQa7gpuV6" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="block text-24 mb-2 customHover2"
                >
                  {t('iletisim.address1')}
                </a>
                <a 
                  href="tel:+902582691095" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="block text-18 mb-4 customHover2"
                >
                  +90 (258) 269 10 95
                </a>
              </div>
            </div>
            {/* Sağ sütun */}
            <div className="flex flex-col">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3054.0403146374947!2d29.244060999999995!3d37.800402999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c718320c4434d1%3A0x74d5ff5abd3cf52c!2sG%C3%96KDELEN%20%C4%B0SKELE%20-%20KALIP!5e1!3m2!1sen!2str!4v1740127259943!5m2!1sen!2str" 
                width="100%" 
                height="275" 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Map 2"
              ></iframe>
              <div className="mt-5">
                <a 
                  href="https://maps.app.goo.gl/dsUurVB8EQEh6e2a7" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="block text-24 mb-2 customHover2"
                >
                  {t('iletisim.address2')}
                </a>
                <a 
                  href="tel:+902582691095" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="block text-18 mb-4 customHover2"
                >
                  +90 (258) 269 10 95
                </a>
              </div>
            </div>
          </div>

          {/* Alt kısım: Sosyal medya ve diğer bilgiler */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Sol sütun */}
            <div className="flex flex-col order-2 md:order-none">
              <div className="flex my-10 space-x-5">
                <a href="https://www.instagram.com/gokdeleniskelekalip/" target="_blank" rel="noreferrer">
                  <img src="/images/header/i.svg" className="customHover cursor-pointer" alt="Instagram" />
                </a>
                <a href="https://www.facebook.com/gokdeleniskelekalip" target="_blank" rel="noreferrer">
                  <img src="/images/header/f.svg" className="customHover cursor-pointer" alt="Facebook" />
                </a>
                <a href="https://www.linkedin.com/company/10594998/admin/dashboard/" target="_blank" rel="noreferrer">
                  <img src="/images/header/li.svg" className="customHover cursor-pointer" alt="LinkedIn" />
                </a>
                <a href="https://www.youtube.com/@gokdeleniskelekalp3165" target="_blank" rel="noreferrer">
                  <img src="/images/header/y.svg" className="customHover cursor-pointer" alt="YouTube" />
                </a>
              </div>
              <div className="flex flex-col md:flex-row justify-between">
                <p className="text-14 font-thin">{t('iletisim.copyright')}</p>
                {/* <p className="text-14 font-thin">{t('iletisim.dealers')}</p> */}
              </div>
            </div>

            {/* Sağ sütun */}
            <div className="inline-flex flex-col items-start md:items-end justify-end space-y-1">
              <h6 className="text-18 font-thin">{t('iletisim.joinTitle')}</h6>
              <a 
                href="mailto:proje@gokdelen.com.tr" 
                className="inline-block font-thin bg-[rgba(183,183,183,0.38)] py-4 px-8 text-16 hover:scale-105 transition-all duration-300 cursor-pointer"
              >
                {t('iletisim.buttonText')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Iletisim;
